import en from '@/locales/en.json';
import sw from '@/locales/sw.json';
import sheng from '@/locales/sheng.json';
import ar from '@/locales/ar.json';
import hi from '@/locales/hi.json';
import ur from '@/locales/ur.json';
import fr from '@/locales/fr.json';
import zh from '@/locales/zh.json';
import ja from '@/locales/ja.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'sw', label: 'Swahili', nativeLabel: 'Kiswahili' },
  { code: 'sheng', label: 'Sheng', nativeLabel: 'Sheng' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'ur', label: 'Urdu', nativeLabel: 'اردو' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'zh', label: 'Chinese', nativeLabel: '中文' },
  { code: 'ja', label: 'Japanese', nativeLabel: '日本語' },
] as const;

export type Language = typeof SUPPORTED_LANGUAGES[number]['code'];

/** Languages that render right-to-left */
export const RTL_LOCALES: Language[] = ['ar', 'ur'];

/** Returns true if the given locale is RTL */
export function isRtlLocale(locale: Language): boolean {
  return RTL_LOCALES.includes(locale);
}

/** Returns 'rtl' or 'ltr' for the given locale */
export function getDirection(locale: Language): 'rtl' | 'ltr' {
  return isRtlLocale(locale) ? 'rtl' : 'ltr';
}

const translations: Record<Language, typeof en> = {
  en,
  sw,
  sheng,
  ar,
  hi,
  ur,
  fr,
  zh,
  ja,
};

export function getTranslations(language: Language): typeof en {
  return translations[language] ?? translations['en'];
}
